import React, { useState, useCallback, useEffect } from 'react'
import Cropper from 'react-easy-crop'
import { Modal } from '@nextui-org/react'

const Confirm = ({ file, setFiles, setFile }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [src, setSrc] = useState("");
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
      }, [])

    useEffect(() => {
       const setImage = async () => {
        if (!file) return null;
        const base = await toBase64(file);
        setSrc(base)
       }

       setImage();
    }, [file]);

    const success = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(src, croppedAreaPixels)

            const type = croppedImage.split(';')[0].split('/')[1];

            const final = dataURLtoFile(croppedImage, "capture." + type)
       
            setFiles(old => [...old, final]);
            setFile(null);
        } catch (e) {
          console.error(e)
        }
      }, [croppedAreaPixels])


    return (
        <>
            <Modal.Header></Modal.Header>
            <Modal.Body css={{ padding: 0 }}>
                <div className='crop'>

                    <div className="crop-container">
                        <Cropper
                            image={src}
                            crop={crop}
                            zoom={zoom}
                            aspect={1 / 1.4142}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ paddingBottom: 0 }}>
            <div className="controls">
                    <input
                        type="range"
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        aria-labelledby="Zoom"
                        style={{ width: 250 }}
                        onChange={(e) => {
                            setZoom(e.target.value)
                        }}
                        className="zoom-range"
                    />
                </div>
                <span style={{ marginTop: 10 }}>
                    <button onClick={() => setFile(null)} className='error'>Retour</button>
                    <button onClick={success}>Confirmer</button>
                </span>
            </Modal.Footer>
        </>
    )
}

function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

function dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
        //Buffer.from(arr[1], 'base64')
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}

export function rotateSize(width, height, rotation) {
    const rotRad = getRadianAngle(rotation)
  
    return {
      width:
        Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
      height:
        Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    }
  }

  export function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180
  }
  
async function getCroppedImg(
    imageSrc,
    pixelCrop,
    rotation = 0,
    flip = { horizontal: false, vertical: false }
  ) {
    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
  
    if (!ctx) {
      return null
    }
  
    const rotRad = getRadianAngle(rotation)
  
    // calculate bounding box of the rotated image
    const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
      image.width,
      image.height,
      rotation
    )
  
    // set canvas size to match the bounding box
    canvas.width = bBoxWidth
    canvas.height = bBoxHeight
  
    // translate canvas context to a central location to allow rotating and flipping around the center
    ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
    ctx.rotate(rotRad)
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
    ctx.translate(-image.width / 2, -image.height / 2)
  
    // draw rotated image
    ctx.drawImage(image, 0, 0)
  
    // croppedAreaPixels values are bounding box relative
    // extract the cropped image using these values
    const data = ctx.getImageData(
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height
    )
  
    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height
  
    // paste generated rotate image at the top left corner
    ctx.putImageData(data, 0, 0)
  
    // As Base64 string
    // return canvas.toDataURL('image/jpeg');
  
    // As a blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(async (file) => {
             const base = await blobToBase64(file);
             console.log(base);
            resolve(base)
      }, 'image/jpeg')
    })
  }
  
  export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => {
        console.log(image);
        resolve(image)
    })
    image.addEventListener('error', (error) => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

export default Confirm;